import React, { Component } from 'react'
import styled from 'styled-components'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

import { setBackground } from 'redux/modules/background'
import scrollOnMount from 'utils/scrollOnMount'
import withPost from 'containers/withPost'
import withSiteMeta from 'containers/withSiteMeta'
import Modules from 'ui/components/Modules'
import Seo from 'ui/components/Seo'
import NotFound from 'ui/components/NotFound'
import Concert from 'ui/components/views/Concert'

const Wrapper = styled.div`
  min-height: 100vh;
`

class Page extends Component {
  componentDidMount() {
    this.handleBackground()
  }

  componentDidUpdate(prevProps) {
    if (!this.props.loading && prevProps.loading) {
      this.handleBackground()
    }

    if (this.props.match.params.slug !== prevProps.match.params.slug) {
      if (
        this.props.post &&
        this.props.post.slug === this.props.match.params.slug
      ) {
        this.handleBackground()
      }
    }
  }

  handleBackground() {
    const { setBackground, post } = this.props

    if (!post) return

    const {
      backgroundType,
      backgroundImage,
      backgroundVideo,
      backgroundColor,
      backgroundOverlay
    } = post

    let background = {
      type: backgroundType || 'default',
      overlay: backgroundOverlay
    }

    switch (backgroundType) {
      case 'image':
        background.image = backgroundImage.sourceUrl
        break
      case 'video':
        background.video = backgroundVideo.mediaItemUrl
        break
      case 'color':
        background.color = backgroundColor
        break
      default:
        break
    }

    setBackground(background)
  }

  render() {
    const { post, loading, type } = this.props

    return (
      <Wrapper>
        {!loading && <Seo seo={post.seo} />}

        {type === 'concert' && post && <Concert post={post} />}

        {post && post.modules && (
          <Modules modules={post.modules} post={post} type={type} />
        )}
      </Wrapper>
    )
  }
}

export default compose(
  scrollOnMount,
  withSiteMeta(),
  withRouter,
  withPost(
    props => props.match.params.slug || props.siteMeta.frontPageSlug,
    props => props.type,
    () => <NotFound />
  ),
  connect(null, { setBackground })
)(Page)



// WEBPACK FOOTER //
// ./src/ui/components/Page.js